const ModalService = require("../../../ceres/services/ModalService");
const ApiService = require("../../../ceres/services/ApiService");

import Vue from "vue";

export default Vue.component("cancel-order", {
	props: {
		template: {
			type: String,
			default: "#vue-cancel-order"
		},
		currentOrder: {
			type: Object
		},
		changePossible: {
			type: Boolean
		},
		currentTemplate: {
			type: String
		}
	},

	data() {
		return {
			cancelOrderModal: {},
			isPending: false,
			showErrorMessage: false
		};
	},

	mounted() {
		this.$nextTick(() => {
			this.cancelOrderModal = ModalService.findModal(this.$refs.cancelOrderModal);
		});
	},

	methods: {
		openCancelOrderModal() {
			this.cancelOrderModal.show();
		},

		closeModal() {
			this.cancelOrderModal.hide();
			this.isPending = false;
		},

		cancelOrder() {
			this.isPending = true;

			ApiService.post("/rest/eros/order/cancel", {
				orderId: this.currentOrder.id,
				accessKey: this.currentOrder.accessKey
			})
				.done(response => {
					window.location.reload();
				})
				.fail(() => {
					// TODO add error msg
				});
		}
	}
});
